@if (state().show) {
<ul class="dropdown-menu dropdown-menu-dark rounded-bottom-start rounded-bottom-end overflow-hidden context-menu mb-0 pb-0 shadow show"
    [style.left.px]="state().x" [style.top.px]="state().y" style="position: fixed; z-index: 100000 !important;">
    @if(!isFriend()) {
    <li><button class="dropdown-item" (click)="onAction('AddFriend')">Add Friend</button></li>
    }

    @if(isFriend()) {
    <li><button class="dropdown-item" (click)="onAction('SendMessage')">Send Message</button></li>
    }

    @if(isFriend() && isFriendList() && arena()) {
    <li><button class="dropdown-item" (click)="onAction('SendInvite')">Send Invite</button></li>
    }

    @if(canPassModerator() && !isFriendList()) {
    <li><button class="dropdown-item" (click)="onAction('PassModerator')">Pass Moderator</button></li>
    }

    @if(canKick() && !isFriendList()) {
    <li>
        <hr class="dropdown-divider">
    </li>
    <li class="bg-danger p-0">
        <button class="btn btn-danger py-3 rounded-0" (click)="onAction('Kick')">Kick {{ player()?.userName
            }}</button>
    </li>
    }

    @if(isFriendList()) {
    <li>
        <hr class="dropdown-divider">
    </li>
    <li class="bg-danger py-2 rounded-bottom-start rounded-bottom-end">
        <button class="btn btn-danger py-3 rounded-0" data-bs-toggle="modal" [attr.data-bs-target]="'#' + getModalId()"
            (click)="closeMenu()">Remove</button>
    </li>
    }
</ul>
}

<!-- Remove Friend Confirmation Modal -->
<div class="modal fade" [id]="getModalId()" tabindex="-1" [attr.aria-labelledby]="getModalId() + 'Label'"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title fw-bold" [id]="getModalId() + 'Label'">Remove Friend</h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"
                    aria-label="Close"></button>
            </div>
            <div class="modal-body text-center py-4">
                <div class="mb-3">
                    <i class="bi bi-person-x-fill text-danger" style="font-size: 3rem;"></i>
                </div>
                Are you sure you want to remove <strong class="text-warning">{{ player()?.userName }}</strong> from your
                friends list?
            </div>
            <div class="modal-footer p-0 border-0 gap-0">
                <button type="button" class="btn btn-dark w-50 m-0 rounded-0 rounded-bottom-start fw-bold"
                    style="height: 4rem;" data-bs-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-danger w-50 m-0 rounded-0 rounded-bottom-end fw-bold"
                    style="height: 4rem;" data-bs-dismiss="modal" (click)="onAction('Remove')">Remove Friend</button>
            </div>
        </div>
    </div>
</div>